import { render } from "./IssuesChart.vue?vue&type=template&id=07c4d9bf&scoped=true"
import script from "./IssuesChart.vue?vue&type=script&lang=js"
export * from "./IssuesChart.vue?vue&type=script&lang=js"

import "./IssuesChart.vue?vue&type=style&index=0&id=07c4d9bf&lang=scss&scoped=true"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c4d9bf"]])

export default __exports__